import React, { Component } from 'react';
import { Link } from 'react-router-dom'

var lodash = require('lodash')

class List extends Component {

  constructor(props) {
    super(props);

    this.state = {
      profils: [],
      fetching: false,
    }
  }

  componentDidMount() {
    this.fetchProfils();
  }

  async fetchProfils() {
    try {
      this.setState({
        fetching: true
      })
      const response = await fetch(localStorage.backoffice_api + '/api/profils/eDataVoicePrc', {
        method: 'GET',
        headers: {
          authorization: localStorage.JWT,
        },
      })
      var profils = lodash.sortBy(await response.json(), 'IDProfil')

      this.setState({
        profils: profils,
      })
    }
    catch (error) {
      console.log(error)
    }
    finally {
      this.setState({
        fetching: false
      })
    }
  }

  render() {

    return (
      <div className='container-fluid'>
        <div className="row">
          <div className="col">

            <h2 className="mb-4">Profils eDataVoice (Poste Relation Client)</h2>
            <div className="d-flex flex-row align-items-center justify-content-between mb-3">
              <Link to='/profils/eDataVoicePrc/create' className='btn btn-light'>
                <i className="fa fa-plus"></i> Ajouter
              </Link>
            </div>

            {this.state.fetching ?
              <div className="d-flex flex-row align-items-center justify-content-center">
                <i className='fa fa-spinner fa-spin fa-fw'></i>
              </div>
              :
              <table className="table table-striped table-hover table-sm">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nom</th>
                  <th>Type de profil</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                  {this.state.profils.map((p) => {
                    return (<tr key={p.IDProfil}>
                      <td className="align-middle">{p.IDProfil}</td>
                      <td className="align-middle">{p.Libelle}</td>
                      <td className="align-middle">{p.ProfilTypeLibelle}</td>
                      <td className="text-right">
                        <Link to={'/profils/eDataVoicePrc/' + p.IDProfil} className="btn btn-primary btn-sm">
                          <i className="fa fa-pencil"></i>
                        </Link>
                      </td>
                    </tr>);
                  })}
                </tbody>
              </table>
            }

          </div>
        </div>
      </div>
    );
  }
}

export default List;
